import locales from '../intl/locales.json';
// Languages written from right to left.
export const RTL_LANGUAGES = ['ar', 'he'];
export const LOCALE_MAP = {
    ar: 'ar-SA',
    bg: 'bg-BG',
    cs: 'cs-CZ',
    de: 'de-DE',
    en: 'en-GB',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    he: 'he-IL',
    it: 'it-IT',
    ja: 'ja-JP',
    nl: 'nl-NL',
    pl: 'pl-PL',
    pt: 'pt-PT',
    sv: 'sv-SE',
    tr: 'tr-TR',
    zh: 'zh-CN',
    nb: 'nb-NO',
    da: 'da-DK',
    hu: 'hu-HU',
    uk: 'uk-UA',
    ru: 'ru-RU',
    ku: 'ku-TR',
};
export function parseLocale(locale) {
    const normalizedLocale = normalizeLocale(locale);
    const parts = normalizedLocale.split(/[-_]/);
    const [language, region] = parts;
    if (!region && !(language in LOCALE_MAP) && isSupportedLanguage(language)) {
        throw new Error(`No locale has been defined for language: "${language}"`);
    }
    return parts;
}
export function normalizeLocale(locale) {
    const normalizedLocale = locale.replace(/_/, '-').toLowerCase();
    if (normalizedLocale.length === 2) {
        return (LOCALE_MAP[normalizedLocale] || normalizedLocale).toLowerCase();
    }
    return normalizedLocale;
}
export function isSupportedLanguage(language) {
    return locales.languages.includes(language);
}
